export default __webpack_public_path__ + "static/media/emoji-neutral-ebe8e7.5e3fa2ff.svg";